// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IncDecrement {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 20px 0px 0px 0px;
  border-radius: 12px;
  background-color: #fff;
  color: grey;
}
.IncDecrement__input__label {
  font-family: "Outfit";
  font-style: normal;
  font-weight: 300;
  font-size: 1.4rem;
  line-height: 1.8rem;
  color: black;
}
.IncDecrement__buttonLeft, .IncDecrement__buttonRight {
  border: none;
  background-color: transparent;
  height: 50px;
  padding: 10px 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.IncDecrement__buttonLeft {
  border-radius: 8px 0px 0px 8px;
  color: #fff;
  font-family: Syne;
  font-size: 2.4rem;
  font-weight: 700;
  background: linear-gradient(92deg, #00aa74 0.17%, #0bd393 100%);
}
.IncDecrement__buttonRight {
  border-radius: 0px 8px 8px 0px;
  color: #fff;
  font-family: Syne;
  font-size: 2.4rem;
  font-weight: 700;
  background: linear-gradient(92deg, #00aa74 0.17%, #0bd393 100%);
}
.IncDecrement__buttonDisabled {
  background: #d9d9d9;
}
.IncDecrement__input__box {
  background-color: transparent;
  border: none;
  text-align: center;
  font-family: "Outfit";
  font-style: normal;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 20px;
  width: 100%;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  color: #1e1e1e;
  outline: none;
  flex: 6;
}
.IncDecrement__InputLoading {
  border: none;
  outline: none;
  color: #d9d9d9;
  background: #f8f8f8;
}
.IncDecrement__loading__box {
  background: #f8f8f8;
  position: absolute;
  left: 45%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.IncDecrement__unit {
  flex: 1;
  display: flex;
  align-items: center;
  color: #333;
  text-align: center;
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
}
.IncDecrement__placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #8c8c8c;
  font-family: Outfit;
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.IncDecrement__focused {
  position: absolute;
  right: 0;
  left: 33vw;
  bottom: 0;
  transform: translateY(0);
  transition: all 0.3s ease;
  pointer-events: none;
  color: #8c8c8c;
  font-family: Outfit;
  font-size: 1.6rem;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/Components/Common/IncDecrement/InDecrement.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;AADJ;AAEI;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;AAAR;AAGI;EAEI,YAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAFR;AAII;EACI,8BAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,+DAAA;AAFR;AAII;EACI,8BAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,+DAAA;AAFR;AAII;EACI,mBAAA;AAFR;AAII;EACI,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,6BAAA;EACA,gCAAA;EACA,cAAA;EACA,aAAA;EACA,OAAA;AAFR;AAII;EACI,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AAFR;AAII;EACI,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFR;AAII;EACI,OAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AAFR;AAII;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFR;AAII;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;EACA,yBAAA;EACA,oBAAA;EAEA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAHR","sourcesContent":["@import '../../../Styles/sass/variables';\n\n.IncDecrement {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    padding: 20px 0px 0px 0px;\n    border-radius: 12px;\n    background-color: #fff;\n    color: grey;\n    &__input__label {\n        font-family: 'Outfit';\n        font-style: normal;\n        font-weight: 300;\n        font-size: 1.4rem;\n        line-height: 1.8rem;\n        color: black;\n    }\n\n    &__buttonLeft,\n    &__buttonRight {\n        border: none;\n        background-color: transparent;\n        height: 50px;\n        padding: 10px 24px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n    }\n    &__buttonLeft {\n        border-radius: 8px 0px 0px 8px;\n        color: #fff;\n        font-family: Syne;\n        font-size: 2.4rem;\n        font-weight: 700;\n        background: linear-gradient(92deg, #00aa74 0.17%, #0bd393 100%);\n    }\n    &__buttonRight {\n        border-radius: 0px 8px 8px 0px;\n        color: #fff;\n        font-family: Syne;\n        font-size: 2.4rem;\n        font-weight: 700;\n        background: linear-gradient(92deg, #00aa74 0.17%, #0bd393 100%);\n    }\n    &__buttonDisabled {\n        background: #d9d9d9;\n    }\n    &__input__box {\n        background-color: transparent;\n        border: none;\n        text-align: center;\n        font-family: 'Outfit';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 1.6rem;\n        line-height: 20px;\n        width: 100%;\n        border-top: 1px solid #d9d9d9;\n        border-bottom: 1px solid #d9d9d9;\n        color: #1e1e1e;\n        outline: none;\n        flex: 6;\n    }\n    &__InputLoading {\n        border: none;\n        outline: none;\n        color: #d9d9d9;\n        background: #f8f8f8;\n    }\n    &__loading__box {\n        background: #f8f8f8;\n        position: absolute;\n        left: 45%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    &__unit {\n        flex: 1;\n        display: flex;\n        align-items: center;\n        color: #333;\n        text-align: center;\n        font-family: Outfit;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        border-top: 1px solid #d9d9d9;\n        border-bottom: 1px solid #d9d9d9;\n    }\n    &__placeholder {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: #8c8c8c;\n        font-family: Outfit;\n        font-size: 1.6rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n    }\n    &__focused {\n        position: absolute;\n        right: 0;\n        left: 33vw;\n        bottom: 0;\n        transform: translateY(0);\n        transition: all 0.3s ease;\n        pointer-events: none;\n        // opacity: 0.5;\n        color: #8c8c8c;\n        font-family: Outfit;\n        font-size: 1.6rem;\n        font-weight: 400;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
